<template>
  <div class="tree">
      <node-tree :node="treeData"></node-tree>
  </div>
</template>

<script>
import NodeTree from "./NodeTree";

export default {
  props: {
    treeData: Array
  },
  components: {
    NodeTree
  },
  mounted(){
  }
};
</script>

<style>
.tree-list ul {
  padding-left: 16px;
  margin: 6px 0;
}
</style>